import { format } from "date-fns"

// Shared notification key so multiple endpoints throttled at once (e.g. records
// and optima-benefit on the results page) collapse into a single notice.
export const RATE_LIMIT_KEY = "rate-limit"
export const RATE_LIMIT_TITLE = "Te veel verzoeken"

/**
 * Build the user-facing message for a throttled (HTTP 429) request. `wait` is
 * the number of seconds until the limit is lifted, as reported by the backend;
 * when present the message names the clock time at which the user can retry.
 */
export function rateLimitMessage(wait) {
  const seconds = Number(wait)
  const retryHint =
    Number.isFinite(seconds) && seconds > 0
      ? `Je kunt het vanaf ${format(new Date(Date.now() + seconds * 1000), "HH:mm")} uur weer proberen.`
      : "Probeer het over enkele ogenblikken opnieuw."
  return `Je hebt te veel verzoeken verstuurd, daarom kan dit nu even niet geladen worden. ${retryHint}`
}
